import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BYPASS_REQUEST_SOURCE_INTERCEPTOR } from '../../constants/bypass-request-source-interceptor.constant';
import { COMMON_CONFIG } from '../../tokens/common-config.token';

export const requestSourceInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const { catalogueStore } = inject(COMMON_CONFIG);

  if (
    !catalogueStore ||
    request.context.get(BYPASS_REQUEST_SOURCE_INTERCEPTOR)
  ) {
    return next(request);
  }

  const updatedRequest = request.clone({
    setHeaders: { 'request-source': catalogueStore },
  });
  return next(updatedRequest);
};
